import { Row, Col, Form, Select } from 'antd'
import classes from '../Pages.module.css';
// import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

const { Option } = Select;

const SalaryForm = (props) => {
    const [filteredEmployees, setFilteredEmployees] = useState([]);

    // Initialize filtered employees with all employees
    useEffect(() => {
        setFilteredEmployees(props.ad.employees.rows);
    }, [props.ad.employees.rows]);

    // const handleChange = (event,param) => {

    //     props.setForm(form => {
    //         let newform = form;
    //         newform[param] = event.target.value
    //         return({
    //             ...form,
    //             ...newform
    //         });
    //     })
    // }

    const handleSChange = (e, param) => {
        props.setForm(form => {
            let newform = form;
            newform[param] = e;

            // If changing department, filter employees
            if (param === "department") {
                if (e) {
                    // Filter employees by selected department using EMP_DET_CODE
                    const filtered = props.ad.employees.rows.filter(
                        emp => emp.EMP_DET_CODE === e
                    );
                    setFilteredEmployees(filtered);
                } else {
                    // If no department selected, show all employees
                    setFilteredEmployees(props.ad.employees.rows);
                }
            }

            return ({
                ...form,
                ...newform
            });
        })
    }

    // const handleDChange = (date, dateString, param) => {

    //     props.setForm(form => {
    //         let newform = form;
    //         newform[param] = dateString
    //         return({
    //             ...form,
    //             ...newform
    //         });
    //     })
    // }

    return (
        <>
            <Form
                layout="vertical">
                <Row gutter={32} style={{ margin: "0.5rem" }} className={classes['RowDE']}>
                    {/* <Col lg = {6} md = {8}>
                    
                        <p></p>
                    </Col>       */}
                    <Col lg={6} md={8}>
                        <Form.Item
                            colon={false}
                            style={{ margin: "0", padding: "0" }}
                            label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']} >Salary Month</div>}
                        >
                            <Select
                                allowClear={true}
                                value={props.form.month}
                                showSearch
                                onChange={(value) => handleSChange(value, "month")}
                                bordered={true}
                                dropdownStyle={{ textTransform: "capitalize" }}
                                style={{ textAlign: "left", width: "100%", backgroundColor: "white", textTransform: "capitalize", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                            >

                                {
                                    props.ad.month.rows.map((option) => {
                                        return (
                                            <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.month.fields[0].name]} value={option[props.ad.month.fields[0].name]}>{option[props.ad.month.fields[1].name]}</Option>
                                        );
                                    })
                                }
                            </Select>

                        </Form.Item>
                        <p></p>
                    </Col>


                    {/* <Col md = {8}>
                      

                         <Form.Item 
                                                    colon = {false}
                                                    style = {{margin: "0", padding: "0"}}
                                                    label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className = {classes['Label']} >CALCULATED SALARY FROM</div>}
                                                >
                                                        <DatePicker
                                                            value = {!props.form.attend_date ? null : dayjs(props.form.attend_date, "DD-MM-YYYY")}
                                                            format="DD-MM-YYYY"
                                                            className = {classes['Date']}
                                                            style={{ textAlign: "left", width: "100%" , backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}}
                                                            bordered = {true}
                                                            onChange={(date, dateString) => handleDChange(date, dateString, "attend_date")} />
                                                            
                                                </Form.Item>
                                                <p></p>
                        <p></p>
                    </Col> */}

                    <Col md={8}>
                        <Form.Item
                            colon={false}
                            style={{ margin: "0", padding: "0" }}
                            label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']} >Department</div>}
                        >
                            <Select
                                allowClear={true}
                                value={props.form.department}
                                showSearch
                                onChange={(value) => handleSChange(value, "department")}
                                bordered={true}
                                dropdownStyle={{ textTransform: "capitalize" }}
                                style={{ textAlign: "left", width: "100%", backgroundColor: "white", textTransform: "capitalize", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                            >

                                {
                                    props.ad.departments.rows.map((option) => {
                                        return (
                                            <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.departments.fields[0].name]} value={option[props.ad.departments.fields[0].name]}>{option[props.ad.departments.fields[1].name]}</Option>
                                        );
                                    })
                                }
                            </Select>

                        </Form.Item>
                        <p></p>
                    </Col>

                    <Col md={8}>
                        <Form.Item
                            colon={false}
                            style={{ margin: "0", padding: "0" }}
                            label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']} >Employee Type</div>}
                        >
                            <Select
                                allowClear={true}
                                value={props.form.emp_type}
                                showSearch
                                onChange={(value) => handleSChange(value, "emp_type")}
                                bordered={true}
                                dropdownStyle={{ textTransform: "capitalize" }}
                                style={{ textAlign: "left", width: "100%", backgroundColor: "white", textTransform: "capitalize", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            // filterSort={(optionA, optionB) =>
                            // optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            // }
                            >

                                {
                                    props.ad.empTypes.rows.map((option) => {
                                        return (
                                            <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.empTypes.fields[0].name]} value={option[props.ad.empTypes.fields[0].name]}>{option[props.ad.empTypes.fields[1].name]}</Option>
                                        );
                                    })
                                }
                            </Select>

                        </Form.Item>
                        <p></p>
                    </Col>

                    <Col md={8}>
                        <Form.Item
                            colon={false}
                            style={{ margin: "0", padding: "0" }}
                            label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']} >Employee Name</div>}
                        >
                            <Select
                                allowClear={true}
                                value={props.form.attend_code}
                                showSearch
                                onChange={(value) => handleSChange(value, "attend_code")}
                                bordered={true}
                                dropdownStyle={{ textTransform: "capitalize" }}
                                style={{ textAlign: "left", width: "100%", backgroundColor: "white", textTransform: "capitalize", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            // filterSort={(optionA, optionB) =>
                            // // optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            // }
                            >

                                {
                                    filteredEmployees.map((option) => {
                                        return (
                                            <Option style={{ textTransform: "capitalize", color: "#1777C4" }} key={option[props.ad.employees.fields[0].name]} value={option[props.ad.employees.fields[0].name]}> {option[props.ad.employees.fields[1].name]} ({option[props.ad.employees.fields[0].name]})</Option>
                                        );
                                    })
                                }
                            </Select>

                        </Form.Item>
                        <p></p>
                    </Col>
                    <Col lg={0} md={6}>

                    </Col>
                    <Col lg={8} md={12}>
                        <p></p>
                        <button onClick={(event) => props.handleSave(event)} className={classes['ProfileButtonF']}>Process Salary</button>
                        <p></p>
                    </Col>
                    <Col lg={0} md={6}>

                    </Col>
                </Row>
            </Form>
        </>
    )
}

export default SalaryForm;
